<template>
  <b-form-textarea
    v-model="internalValue"
    :state="state"
    :placeholder="placeholder"
    :autocomplete="autocomplete"
    :rows="rows"
    :disabled="disabled"
    :size="size"
    trim
    @input="handleInput"
    @blur="handleBlur"
  />
</template>

<script>
export default {
  name: 'TextAreaField',
  props: {
    rows: {
      type: Number,
      default: 3
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    state: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  methods: {
    handleInput(value) {
      !this.disabled && this.$emit('input', value)
    },
    handleBlur(value) {
      !this.disabled && this.$emit('blur', value)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
